import { useSelectionManager } from "@prismicio/editor-fields"
import { useLocation } from "react-router-dom"
import { z } from "zod"

import { useHasBulkActionsPermission } from "../DocumentList.utils"
import { useDocumentDataSearch } from "../DocumentListBody/useDocumentData"
import { useBulkAction } from "./BulkActionsProvider"

export function useBulkActionsButton() {
  const { documentsInQueue } = useBulkAction()
  const { selectedCount, isSelected } = useSelectionManager()
  const hasPermission = useHasBulkActionsPermission()
  const tab = useTabFromRoute()
  const { action } = useBulkAction()

  const { documents } = useDocumentDataSearch({ tab })

  function getSelectedDocuments() {
    return documents.filter(
      (document) =>
        isSelected(document.id) &&
        !documentsInQueue.find((queuedDocument) =>
          "documentId" in queuedDocument
            ? queuedDocument.documentId === document.id
            : queuedDocument.documentGroupLangId === document.group_lang_id
        )
    )
  }

  let disabled = false
  let tooltip: string | undefined = undefined

  if (!hasPermission) {
    disabled = true
    tooltip = "Your current role can't perform this action"
  } else if (selectedCount === 0) {
    disabled = true
    tooltip = "No documents selected"
  } else if (selectedCount === documentsInQueue.length) {
    disabled = true
    tooltip = "All documents are already being processed"
  }

  return {
    action,
    disabled,
    tooltip,
    getSelectedDocuments
  }
}

const tabSchema = z.enum(["working", "archived", "upcoming"])

function useTabFromRoute() {
  const location = useLocation()
  const pathSegments = location.pathname
    .split("/")
    .filter((segment) => segment !== "")
  const extractedTab = pathSegments[0]

  return tabSchema.parse(extractedTab)
}
